import { useMutation } from '@tanstack/react-query';

import { apiRequestBlob } from '@/lib/api-client';

export interface PreviewInvoicePdfOptions {
  // Non-final sell rows only: render the running history of the row's
  // predecessors instead of just its own value. A per-request choice — nothing
  // is persisted. Absent defaults to the single-value document.
  readonly includeChainHistory: boolean;
}

// Render a non-authoritative preview of the invoice on a Draft. The endpoint
// streams the PDF bytes (marked "preview — not issued") and persists nothing —
// no document, no invoice.document_id — so this is safe to call repeatedly and
// does not need to invalidate any cache. It reflects the invoice's saved review
// state, so callers persist edits before previewing.
export function usePreviewInvoicePdf(invoiceId: string) {
  return useMutation<Blob, Error, PreviewInvoicePdfOptions>({
    mutationFn: (options) =>
      apiRequestBlob(`/invoices/${encodeURIComponent(invoiceId)}/pdf/preview`, {
        method: 'POST',
        headers: { Accept: 'application/pdf' },
        body: { include_chain_history: options.includeChainHistory },
      }),
  });
}
